export default __webpack_public_path__ + "static/media/android.905c3e95.png";